var choices = function(c,a) {
    var i = 1;
    var string = '';
    var choices = [ c.choice_1, c.choice_2, c.choice_3, c.choice_4, c.choice_5];
    _(choices).each(function(row) {
        var checked = '';
        if ( typeof a !== 'undefined' && a == i ) {
            checked = ' checked="checked" ';
        }
        if (row.length) {
            string += '<label for="choice_'+ i +'">' +
                '<div class="list-group-item">' +
                '<input type="radio" id="choice_'+ i +'" name="answer" value="'+i+'" '+ checked +'/> ' +
                i++ +'. '+ row +
                '</div>' +
                '</label>';
        }

    }) ;

    return $.parseHTML(string);
}
module.exports = choices





//////////////////
// WEBPACK FOOTER
// ./src/choices.js
// module id = 298
// module chunks = 0